import React from 'react';
import {ScenarioAttemptResult} from '@types';
import {useTranslation} from 'react-i18next';

type ResultBadgeProps = {
    result: ScenarioAttemptResult;
    didResign?: boolean;
};

const getResultDisplay = (result: ScenarioAttemptResult) => {
    const displays = {
        [ScenarioAttemptResult.SUCCESS]: {
            textKey: 'invasions.status_success',
            className: 'bg-success-subtle text-success-emphasis',
        },
        [ScenarioAttemptResult.FAILURE]: {
            textKey: 'common.failed',
            className: 'bg-danger-subtle text-danger-emphasis',
        },
        [ScenarioAttemptResult.IN_PROGRESS]: {
            textKey: 'common.in_progress',
            className: 'bg-info-subtle text-info-emphasis',
        },
    };

    return (
        displays[result] || {
            textKey: 'common.unknown',
            className: 'bg-secondary-subtle text-secondary-emphasis',
        }
    );
};

export const ScenarioResultBadge: React.FC<ResultBadgeProps> = ({
    result,
    didResign,
}) => {
    const {t} = useTranslation();

    if (didResign && result === ScenarioAttemptResult.FAILURE) {
        return (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-secondary-subtle text-secondary-emphasis">
                {t('invasions.status_resigned')}
            </span>
        );
    }

    const {textKey, className} = getResultDisplay(result);
    return (
        <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium ${className}`}>
            {t(textKey)}
        </span>
    );
};
